export default {
    getOnlineUserList(params, response) {
        window.vue.$apiAxios.get('/tdcache/authCache/getOnlineUserList', params, response);
    }
};
